"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useTranslations } from "next-intl";
import { versionUpdateToast } from "@/lib/toast";
import { useAppVersion } from "@sukha/query";
import { APP_VERSION } from "@/constants/version";

// Polls the server for the latest version and shows a top-right toast
// prompting the user to refresh when a newer version is available.
export default function AppVersionWatcher() {
  const $ = _c(4);
  const t = useTranslations("System.update");
  const {
    data: serverVersion
  } = useAppVersion(900000);
  const shownRef = useRef(false);
  let t0;
  let t1;
  if ($[0] !== serverVersion || $[1] !== t) {
    t0 = () => {
      if (!serverVersion) {
        return;
      }
      if (serverVersion !== APP_VERSION && !shownRef.current) {
        shownRef.current = true;
        versionUpdateToast(t("available"), {
          label: t("refresh"),
          onClick: _temp
        });
      }
    };
    t1 = [serverVersion, t];
    $[0] = serverVersion;
    $[1] = t;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
function _temp() {
  window.location.reload();
}